import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle size={64} strokeWidth={1.5} className="mx-auto text-[color:var(--text-muted)]"/>
      <h1 className="font-serif text-5xl mt-6 leading-none" style={{color: "var(--primary)"}}>Payment cancelled.</h1>
      <p className="mt-4 text-[color:var(--text-muted)]">No worries — your order draft is saved. Continue anytime from your dashboard.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/custom-order"><Button className="btn-primary rounded-full px-7 py-6">Try again</Button></Link>
        <Link to="/dashboard"><Button variant="outline" className="rounded-full px-7 py-6">Go to dashboard</Button></Link>
      </div>
    </div>
  );
}
